/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StatsOperationTagDto } from './StatsOperationTagDto';

export type StatsOperationHighUsageUnmonitoredDatasetDto = {
    datasourceName: string;
    datasourceType: StatsOperationHighUsageUnmonitoredDatasetDto.datasourceType;
    id: string;
    name: string;
    queryCount: number;
    status: StatsOperationHighUsageUnmonitoredDatasetDto.status;
    tags: Array<StatsOperationTagDto>;
    terms: Array<StatsOperationTagDto>;
    urn: string;
    usageQualification: StatsOperationHighUsageUnmonitoredDatasetDto.usageQualification;
};

export namespace StatsOperationHighUsageUnmonitoredDatasetDto {

    export enum datasourceType {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        POWER_BI = 'POWER_BI',
        QUICKSIGHT = 'QUICKSIGHT',
        TABLEAU = 'TABLEAU',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        COMPOSER = 'COMPOSER',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        ADF = 'ADF',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        ATLAN = 'ATLAN',
        DECLARATIVE = 'DECLARATIVE',
        _UNKNOWN_ = '_UNKNOWN_',
    }

    export enum status {
        CRITICAL = 'CRITICAL',
        AT_RISK = 'AT_RISK',
        HEALTHY = 'HEALTHY',
        UNMONITORED = 'UNMONITORED',
        NOT_SUPPORTED = 'NOT_SUPPORTED',
        MISSING = 'MISSING',
    }

    export enum usageQualification {
        UNSUPPORTED = 'UNSUPPORTED',
        LOW = 'LOW',
        MEDIUM = 'MEDIUM',
        HIGH = 'HIGH',
    }


}
